import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { useState as h, useEffect as w } from "react";
import { Button as g } from "antd";
const d = () => {
  const [l, e] = h(
    typeof window < "u" ? window.innerWidth : 0
  );
  return w(() => {
    if (typeof window > "u") return;
    const n = () => e(window.innerWidth);
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), l;
}, i = 768, l1 = ({
  children: l,
  logo: e,
  image: n,
  imageMobile: r,
  label: t,
  isBodyFullScreenMobile: c = !1,
  isLogoTopMobile: s = !1
}) => {
  const v = d();
  return /* @__PURE__ */ o("div", { className: "c-auth", children: [
    n && !(c && v < i) && /* @__PURE__ */ o("div", { className: "c-auth-image", children: [
      /* @__PURE__ */ o("div", { className: `c-auth-logo${s ? " c-auth-logo--top" : ""}`, children: [
        /* @__PURE__ */ a("img", { src: e.image, alt: e.alt, width: e.width, height: e.height }),
        t && /* @__PURE__ */ a("span", { className: "c-auth-logo-label", children: t })
      ] }),
      /* @__PURE__ */ a(
        "div",
        {
          className: "c-auth-picture",
          style: {
            backgroundImage: `url(${r && v < i ? r : n})`
          }
        }
      )
    ] }),
    /* @__PURE__ */ a("div", { className: `c-auth-body ${c ? "c-auth-body--full" : ""}`, children: l })
  ] });
}, m = {
  default: "default",
  primary: "primary",
  secondary: "default",
  dark: "default",
  gray: "default",
  "gray-filled": "default",
  danger: "default",
  "default-danger": "default",
  text: "text",
  "text-danger": "text",
  link: "link"
}, p = {
  secondary: "ant-btn-secondary",
  dark: "ant-btn-dark",
  gray: "ant-btn-gray",
  "gray-filled": "ant-btn-gray-filled",
  danger: "ant-btn-danger",
  "default-danger": "ant-btn-default-danger",
  "text-danger": "ant-btn-text-danger"
}, o1 = ({ type: l = "default", className: e, ...n }) => {
  const r = p[l], t = [e, r].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ a(g, { ...n, type: m[l], className: t });
}, e1 = ({ children: l }) => /* @__PURE__ */ a("div", { className: "c-count", children: l }), n1 = ({ children: l, type: e }) => /* @__PURE__ */ a(
  "div",
  {
    className: `c-tag${e === "success" ? " c-tag--success" : ""}${e === "danger" ? " c-tag--danger" : ""}${e === "progress" ? " c-tag--progress" : ""}`,
    children: l
  }
), f = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M12.667 7.333h-4v-4a.667.667 0 1 0-1.334 0v4h-4a.667.667 0 0 0 0 1.333h4v4a.667.667 0 1 0 1.334 0v-4h4a.667.667 0 1 0 0-1.333"
  }
) }), u = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M14 7.333A8.09 8.09 0 0 1 7.333.667 8.09 8.09 0 0 1 .667 7.333 8.09 8.09 0 0 1 7.333 14 8.09 8.09 0 0 1 14 7.333M15.333 12.667A3.235 3.235 0 0 1 12.667 10 3.235 3.235 0 0 1 10 12.667a3.24 3.24 0 0 1 2.667 2.666 3.24 3.24 0 0 1 2.666-2.666"
  }
) }), x = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "url(#aiColored_svg__a)",
      stroke: "#fff",
      strokeWidth: 1.5,
      d: "M6 .991c.125 0 .28.024.433.099s.369.24.45.54a4.97 4.97 0 0 0 3.487 3.486c.3.082.465.299.54.451a.99.99 0 0 1 0 .866.85.85 0 0 1-.54.45 4.97 4.97 0 0 0-3.486 3.487.85.85 0 0 1-.451.54.99.99 0 0 1-.866 0 .85.85 0 0 1-.45-.54A4.97 4.97 0 0 0 1.63 6.884a.85.85 0 0 1-.54-.451.99.99 0 0 1 0-.866.85.85 0 0 1 .54-.45l.313-.097a4.97 4.97 0 0 0 3.173-3.39l.036-.107a.86.86 0 0 1 .415-.433A1 1 0 0 1 6 .99Z"
    }
  ),
  /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ o("linearGradient", { id: "aiColored_svg__a", x1: 11, x2: -4.172, y1: 6, y2: 6, gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ a("stop", { stopColor: "#FF4D4F" }),
    /* @__PURE__ */ a("stop", { offset: 0.5, stopColor: "#FF8148" }),
    /* @__PURE__ */ a("stop", { offset: 1, stopColor: "#FFD23C" })
  ] }) })
] }), M = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: [
  /* @__PURE__ */ a("g", { clipPath: "url(#aiMenu_svg__a)", children: /* @__PURE__ */ a(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      d: "M10 1a15.23 15.23 0 0 0 9 9 15.23 15.23 0 0 0-9 9 15.23 15.23 0 0 0-9-9 15.23 15.23 0 0 0 9-9"
    }
  ) }),
  /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "aiMenu_svg__a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h20v20H0z" }) }) })
] }), C = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M6.667 9.333h2.666a.667.667 0 1 0 0-1.333H6.667a.667.667 0 0 0 0 1.333m6-7.333H3.333a2 2 0 0 0-2 2v2A.667.667 0 0 0 2 6.667h.667V12a2 2 0 0 0 2 2h6.666a2 2 0 0 0 2-2V6.667H14A.667.667 0 0 0 14.667 6V4a2 2 0 0 0-2-2M12 12a.667.667 0 0 1-.667.667H4.667A.667.667 0 0 1 4 12V6.667h8zm1.333-6.667H2.667V4a.667.667 0 0 1 .666-.667h9.334a.667.667 0 0 1 .666.667z"
  }
) }), V = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "m6.29 14.29-.29.3V7a1 1 0 1 0-2 0v7.59l-.29-.3a1.004 1.004 0 1 0-1.42 1.42l2 2a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l2-2a1.003 1.003 0 1 0-1.42-1.42M11 8h10a1 1 0 1 0 0-2H11a1 1 0 1 0 0 2m10 3H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2m0 5H11a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2"
  }
) }), H = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M14 10.666H4.667a.667.667 0 1 1 0-1.333h6.96a2 2 0 0 0 1.94-1.513l1.1-4.327a.666.666 0 0 0-.363-.765.7.7 0 0 0-.304-.062H4.507a2 2 0 0 0-1.88-1.333H2a.667.667 0 0 0 0 1.333h.627a.67.67 0 0 1 .666.507l.04.32L4.487 8a2.002 2.002 0 0 0 .18 4h.12a2 2 0 1 0 3.76 0h1.573a2 2 0 1 0 3.76 0H14a.667.667 0 0 0 0-1.334M13.147 4l-.874 3.493a.67.67 0 0 1-.666.507H5.853l-1-4zm-6.48 9.333a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334m5.333 0a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334"
  }
) }), A = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      d: "M7.656 7.588q-.303.26-.608.517l-1.035.883-1.45 1.235-1.32 1.123c-.221.187-.448.37-.663.564l-.01.008c-.115.098-.182.295-.182.442a.626.626 0 0 0 .625.625.7.7 0 0 0 .442-.183q.27-.233.543-.462l1.268-1.078 1.464-1.247 1.115-.95.607-.517.089-.077c.115-.098.182-.295.182-.442a.626.626 0 0 0-.625-.625.7.7 0 0 0-.442.184m.664-3.132V.978q-.533.22-1.067.442l.452.351 1.084.846q.656.51 1.311 1.022.566.44 1.128.88c.184.143.366.291.553.43l.008.007V4.07l-.775.66-1.236 1.053-.286.244c-.115.098-.183.295-.183.442a.626.626 0 0 0 .625.625.7.7 0 0 0 .443-.183l.775-.66L12.388 5.2l.285-.244a.63.63 0 0 0 .183-.442c-.006-.154-.056-.343-.183-.443l-.451-.351q-.543-.422-1.084-.845L9.827 1.853q-.566-.44-1.129-.88L8.145.542 8.138.535a.8.8 0 0 0-.277-.16.6.6 0 0 0-.406.03.63.63 0 0 0-.385.573v3.478c0 .326.288.64.625.625.338-.016.625-.275.625-.625"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      d: "M7.07 7.628v6.398c0 .327-.008.655 0 .982v.014c0 .25.158.475.385.571a.6.6 0 0 0 .323.043c.149-.02.24-.08.36-.172l1.41-1.1 2.233-1.74.513-.398c.117-.09.183-.301.183-.442a.625.625 0 0 0-.625-.625l-.166.022a.6.6 0 0 0-.277.161l-1.41 1.1-2.233 1.739q-.255.2-.513.398l1.067.443V7.629c0-.326-.287-.64-.625-.625-.339.015-.625.274-.625.624"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      d: "m14.317 13.367-.614-.615-1.476-1.476L10.44 9.49 8.897 7.946c-.25-.25-.495-.505-.75-.75l-.011-.01.183.441c0-.27-.164-.423-.333-.59l-.39-.39L6.28 5.331l-1.62-1.62-1.4-1.4c-.228-.228-.455-.461-.686-.686l-.01-.01c-.23-.23-.656-.248-.884 0-.23.25-.247.638 0 .885l.558.558 1.336 1.336 1.602 1.601 1.387 1.388c.219.218.433.447.66.659q.014.014.03.027l-.184-.443c0 .285.164.427.338.6l.44.441 1.477 1.477 1.786 1.786 1.558 1.557c.251.252.501.508.756.757l.011.01c.231.232.656.249.884 0 .227-.254.244-.642-.003-.888"
    }
  )
] }), S = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M7.667 12.335a.666.666 0 1 0 0 1.332.666.666 0 0 0 0-1.332m6-10A.667.667 0 0 0 13 1.668H2.333a.667.667 0 0 0-.666.667V13a.667.667 0 1 0 1.333 0v-10h10a.667.667 0 0 0 .667-.666m-3.334 10a.666.666 0 1 0 0 1.333.666.666 0 0 0 0-1.333m-5.333 0a.666.666 0 1 0 0 1.332.666.666 0 0 0 0-1.332m8-8a.666.666 0 1 0 0 1.333.666.666 0 0 0 0-1.333M13 7a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m0 2.667a.667.667 0 1 0 0 1.333.667.667 0 0 0 0-1.333m0 2.667a.666.666 0 1 0 0 1.332.666.666 0 0 0 0-1.332"
  }
) }), B = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M9.5 2h-1v-.5a.5.5 0 1 0-1 0V2h-3v-.5a.5.5 0 1 0-1 0V2h-1A1.5 1.5 0 0 0 1 3.5v6A1.5 1.5 0 0 0 2.5 11h7A1.5 1.5 0 0 0 11 9.5v-6A1.5 1.5 0 0 0 9.5 2m.5 7.5a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V6h8zM10 5H2V3.5a.5.5 0 0 1 .5-.5h1v.5a.5.5 0 1 0 1 0V3h3v.5a.5.5 0 1 0 1 0V3h1a.5.5 0 0 1 .5.5z"
  }
) }), L = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4 7H1V4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2V7h-3M4 7v8m0-8h3m-3 8H2m2 0h3m2 0H7m0 0v-5m0-3v3m0-3h5m-5 3 5 1V7"
  }
) }), z = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 9H5m3 0v3m0-3h7m-7 9h2m-2 0H5m3 0v-6m-5 6h2m0 0V9m0 0H1V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 2 3.08 2 4.2 2h11.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C19 3.52 19 4.08 19 5.2V9h-4m-7 3 7 1V9"
  }
) }), k = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M4.667 10.667a1 1 0 0 0 1-1 .5.5 0 0 0 0-.1l1.86-1.86h.306l1.074 1.074v.053a1 1 0 1 0 2 0v-.053l2.426-2.447a1 1 0 1 0-1-1 .5.5 0 0 0 0 .1L9.927 7.841H9.82L8.667 6.667a1 1 0 0 0-2 0l-2 2a1 1 0 1 0 0 2m9 2.667H2.333V2.001A.667.667 0 1 0 1 2v12a.667.667 0 0 0 .667.666h12a.667.667 0 0 0 0-1.333"
  }
) }), y = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M14 13.334h-.667v-10a.667.667 0 1 0-1.333 0v10h-1.333V6a.667.667 0 1 0-1.334 0v7.334H8V8.667a.667.667 0 0 0-1.333 0v4.667H5.333v-2a.667.667 0 1 0-1.333 0v2H2.667V2a.667.667 0 1 0-1.334 0v12a.667.667 0 0 0 .667.667h12a.667.667 0 1 0 0-1.333"
  }
) }), R = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M18.71 7.21a1 1 0 0 0-1.42 0l-7.45 7.46-3.13-3.14a1.024 1.024 0 0 0-1.445.025A1.02 1.02 0 0 0 5.29 13l3.84 3.84a1 1 0 0 0 1.42 0l8.16-8.16a1 1 0 0 0 0-1.47"
  }
) }), q = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.214 16.833a.976.976 0 1 1-1.38 1.38L12 13.382l-4.833 4.833a.976.976 0 0 1-1.38-1.38L10.618 12 5.786 7.167a.976.976 0 1 1 1.381-1.381L12 10.619l4.833-4.833a.976.976 0 1 1 1.381 1.38L13.381 12z",
    clipRule: "evenodd"
  }
) }), _ = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.999 19.167a.833.833 0 0 1-.833-.833V17.5a.833.833 0 1 1 0-1.666V4.167a.833.833 0 1 1 0-1.667v-.833a.833.833 0 1 1 1.666 0V2.5H15a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-4.167v.834c0 .46-.373.833-.833.833m.833-3.333H15c.46 0 .833-.373.833-.834V5A.833.833 0 0 0 15 4.167h-4.167zm-4.166.833c0 .46-.373.833-.834.833H5a2.5 2.5 0 0 1-2.5-2.5v-.833a.833.833 0 0 1 1.667 0V15c0 .46.373.834.833.834h.833c.46 0 .834.373.834.833m-3.334-5a.833.833 0 0 1-.833-.833V9.167a.833.833 0 1 1 1.667 0v1.667c0 .46-.373.833-.834.833m0-5a.833.833 0 0 1-.833-.833V5a2.5 2.5 0 0 1 2.5-2.5h.833a.833.833 0 1 1 0 1.667H5A.833.833 0 0 0 4.166 5v.834c0 .46-.373.833-.834.833",
    clipRule: "evenodd"
  }
) }), W = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.169 18.333a.833.833 0 0 0 1.666 0v-.417c0-.23.187-.417.417-.417h3.75a2.5 2.5 0 0 0 2.5-2.5V5a2.5 2.5 0 0 0-2.5-2.5h-3.75a.417.417 0 0 1-.417-.416v-.417a.833.833 0 0 0-1.666 0v.417c0 .23-.198.408-.4.518a.833.833 0 0 0 0 1.463c.202.11.4.289.4.519v10.833c0 .23-.198.408-.4.519a.833.833 0 0 0 0 1.463c.202.11.4.288.4.518zm-3.334-.834a.833.833 0 1 0 0-1.666h-.833a.833.833 0 0 1-.833-.834v-.833a.833.833 0 0 0-1.667 0v.833a2.5 2.5 0 0 0 2.5 2.5zm-3.333-6.666a.833.833 0 1 0 1.667 0V9.166a.833.833 0 0 0-1.667 0zm0-5a.833.833 0 1 0 1.667 0v-.834c0-.46.373-.833.833-.833h.833a.833.833 0 1 0 0-1.667h-.833a2.5 2.5 0 0 0-2.5 2.5z",
    clipRule: "evenodd"
  }
) }), F = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 17 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    d: "M6.89 1.834h2.65q.01.001.02.006l.15.086.026-.005 3.95 3.95.023.069.014.06v4a1.5 1.5 0 0 1-1.5 1.5h-1.167v1.166a1.5 1.5 0 0 1-1.5 1.5H4.223a1.5 1.5 0 0 1-1.5-1.5V6l.007-.148A1.5 1.5 0 0 1 4.223 4.5H5.39V3.334a1.5 1.5 0 0 1 1.5-1.5Zm-2.667 3A1.167 1.167 0 0 0 3.056 6v6.666a1.17 1.17 0 0 0 1.167 1.168h5.333a1.167 1.167 0 0 0 1.167-1.168v-1.165H6.89a1.5 1.5 0 0 1-1.5-1.5V4.834zM6.89 2.167a1.17 1.17 0 0 0-1.167 1.167V10a1.166 1.166 0 0 0 1.167 1.165h5.333a1.167 1.167 0 0 0 1.167-1.165V6.167h-2.5a1.5 1.5 0 0 1-1.5-1.5v-2.5zm2.833 2.5a1.167 1.167 0 0 0 1.167 1.167h2.266L9.723 2.4z"
  }
) }), b = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2 2v2m0 14v-2M2 4h12v4M2 4v4m12 0H2m12 0h4v4h-7M2 8v4m0 0h9m-9 0v4m9-4v4H2"
  }
) }), Z = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 160 160", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M75.765 2.161c2.088-2.881 6.382-2.881 8.47 0l5.982 8.254a5.23 5.23 0 0 0 6.973 1.388l8.685-5.337c3.032-1.864 6.999-.22 7.825 3.241l2.368 9.915a5.23 5.23 0 0 0 5.912 3.95l10.066-1.607c3.514-.561 6.55 2.475 5.989 5.99l-1.607 10.066a5.23 5.23 0 0 0 3.95 5.911l9.915 2.368c3.461.826 5.104 4.793 3.241 7.825l-5.336 8.685a5.23 5.23 0 0 0 1.387 6.973l8.254 5.982c2.881 2.088 2.881 6.382 0 8.47l-8.254 5.982a5.23 5.23 0 0 0-1.387 6.973l5.336 8.685c1.863 3.032.22 6.999-3.241 7.825l-9.915 2.368a5.23 5.23 0 0 0-3.95 5.912l1.607 10.066c.561 3.514-2.475 6.55-5.989 5.989l-10.066-1.607a5.23 5.23 0 0 0-5.912 3.95l-2.368 9.915c-.826 3.461-4.793 5.105-7.825 3.241l-8.685-5.336a5.23 5.23 0 0 0-6.973 1.387l-5.982 8.254c-2.088 2.881-6.382 2.881-8.47 0l-5.982-8.254a5.23 5.23 0 0 0-6.973-1.387l-8.685 5.336c-3.032 1.864-6.999.22-7.825-3.241l-2.368-9.915a5.23 5.23 0 0 0-5.912-3.95l-10.066 1.607c-3.514.561-6.55-2.475-5.989-5.989l1.607-10.066a5.23 5.23 0 0 0-3.95-5.912L9.707 113.7c-3.461-.826-5.105-4.793-3.241-7.825l5.337-8.685a5.23 5.23 0 0 0-1.388-6.973l-8.254-5.982c-2.881-2.088-2.881-6.382 0-8.47l8.254-5.982a5.23 5.23 0 0 0 1.388-6.973l-5.337-8.685c-1.864-3.032-.22-6.999 3.241-7.825l9.915-2.368a5.23 5.23 0 0 0 3.95-5.912l-1.607-10.066c-.561-3.514 2.475-6.55 5.99-5.989l10.066 1.607a5.23 5.23 0 0 0 5.911-3.95L46.3 9.707c.826-3.461 4.793-5.105 7.825-3.241l8.685 5.337a5.23 5.23 0 0 0 6.973-1.388z"
  }
) }), D = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M11 3.333a3.24 3.24 0 0 0-1.666.46 4 4 0 0 0-7.667 1.54V8A4 4 0 0 0 5 11.94V14a.667.667 0 1 0 1.334 0v-2.06a4.05 4.05 0 0 0 1.853-.84 3.33 3.33 0 0 0 2.147 1.5V14a.667.667 0 1 0 1.333 0v-1.4a3.33 3.33 0 0 0 2.667-3.267V6.667A3.333 3.333 0 0 0 11 3.333M7.667 6.667v2.666q.01.191.04.38a2.67 2.67 0 0 1-1.373.867V8.667a.667.667 0 0 0-1.334 0v1.906A2.666 2.666 0 0 1 3 8V5.333A2.667 2.667 0 0 1 7.554 3.44c.36.366.606.83.706 1.333a3.33 3.33 0 0 0-.593 1.894M13 9.333a2 2 0 0 1-1.333 1.88V8.667a.666.666 0 1 0-1.333 0v2.546A2 2 0 0 1 9 9.333V6.667a2 2 0 1 1 4 0z"
  }
) }), T = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M19.054 15.429a3.5 3.5 0 0 0-1.794-.963 3.63 3.63 0 0 0-2.05.176l-1.888-2.46L18.73 5.53a.93.93 0 0 0 .207-.7.9.9 0 0 0-.123-.351 1 1 0 0 0-.255-.28 1 1 0 0 0-.737-.19q-.197.026-.368.12a1 1 0 0 0-.291.246l-5.057 6.222L7.35 4.395a1 1 0 0 0-.647-.37c-.258-.037-.521.025-.732.172s-.353.367-.394.612a.9.9 0 0 0 .173.7l5.094 6.64-2.034 2.503a3.6 3.6 0 0 0-1.442-.258 3.55 3.55 0 0 0-2.404 1.017A3.22 3.22 0 0 0 4 17.743a3.23 3.23 0 0 0 1.032 2.305 3.56 3.56 0 0 0 2.537.95 3.6 3.6 0 0 0 1.75-.507c.526-.316.952-.76 1.235-1.286a3.17 3.17 0 0 0-.212-3.355l1.718-2.114 1.608 2.097a3.17 3.17 0 0 0-.228 3.363c.283.529.71.975 1.235 1.292a3.6 3.6 0 0 0 1.859.512c.677 0 1.34-.19 1.905-.544a3.35 3.35 0 0 0 1.278-1.452 3.16 3.16 0 0 0 .23-1.882 3.25 3.25 0 0 0-.893-1.693M7.511 19.11a1.5 1.5 0 0 1-.573-.09 1.5 1.5 0 0 1-.49-.295 1.4 1.4 0 0 1-.429-.713 1.35 1.35 0 0 1 .06-.82c.104-.262.288-.489.527-.65.24-.163.525-.254.819-.262h.044c.39 0 .764.147 1.042.408.277.261.436.616.441.987a1.38 1.38 0 0 1-.412.999c-.27.268-.639.425-1.029.436m10.04-.385c-.141.129-.308.23-.49.295a1.5 1.5 0 0 1-.573.09 1.52 1.52 0 0 1-1.03-.436 1.38 1.38 0 0 1-.411-.999c.005-.371.164-.726.441-.987a1.53 1.53 0 0 1 1.086-.408c.294.008.58.099.819.261.24.162.423.389.527.65.105.262.126.548.06.82a1.4 1.4 0 0 1-.429.714"
  }
) }), N = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.8 2H3.422c-.498 0-.747 0-.937.097a.9.9 0 0 0-.388.388C2 2.675 2 2.925 2 3.422V6.8c0 .498 0 .747.097.937a.9.9 0 0 0 .388.388c.19.097.44.097.937.097H6.8c.498 0 .747 0 .937-.097a.9.9 0 0 0 .388-.388c.097-.19.097-.44.097-.937V3.422c0-.498 0-.747-.097-.937a.9.9 0 0 0-.388-.388C7.547 2 7.297 2 6.8 2m9.778 0H13.2c-.498 0-.747 0-.937.097a.9.9 0 0 0-.388.388c-.097.19-.097.44-.097.937V6.8c0 .498 0 .747.097.937a.9.9 0 0 0 .388.388c.19.097.44.097.937.097h3.378c.498 0 .747 0 .937-.097a.9.9 0 0 0 .388-.388C18 7.547 18 7.297 18 6.8V3.422c0-.498 0-.747-.097-.937a.9.9 0 0 0-.388-.388C17.325 2 17.075 2 16.578 2m0 9.778H13.2c-.498 0-.747 0-.937.097a.9.9 0 0 0-.388.388c-.097.19-.097.44-.097.937v3.378c0 .498 0 .747.097.937a.9.9 0 0 0 .388.388c.19.097.44.097.937.097h3.378c.498 0 .747 0 .937-.097a.9.9 0 0 0 .388-.388c.097-.19.097-.44.097-.937V13.2c0-.498 0-.747-.097-.937a.9.9 0 0 0-.388-.388c-.19-.097-.44-.097-.937-.097m-9.778 0H3.422c-.498 0-.747 0-.937.097a.9.9 0 0 0-.388.388C2 12.453 2 12.703 2 13.2v3.378c0 .498 0 .747.097.937a.9.9 0 0 0 .388.388c.19.097.44.097.937.097H6.8c.498 0 .747 0 .937-.097a.9.9 0 0 0 .388-.388c.097-.19.097-.44.097-.937V13.2c0-.498 0-.747-.097-.937a.9.9 0 0 0-.388-.388c-.19-.097-.44-.097-.937-.097"
  }
) }), E = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "m3.76 11.333-.473.474a.667.667 0 0 0 0 .94.666.666 0 0 0 .94 0l.473-.474a.667.667 0 0 0-.94-.94M3.334 8a.667.667 0 0 0-.667-.667H2a.667.667 0 0 0 0 1.334h.667A.667.667 0 0 0 3.334 8M8 3.333a.667.667 0 0 0 .667-.666V2a.667.667 0 0 0-1.333 0v.667A.667.667 0 0 0 8 3.333M3.76 4.7a.667.667 0 0 0 1.134-.47.67.67 0 0 0-.194-.47l-.473-.473a.667.667 0 0 0-.94.94zm8 .193c.175 0 .343-.07.467-.193l.473-.473a.667.667 0 1 0-.94-.94l-.426.473a.667.667 0 0 0 .44 1.133zM14 7.333h-.666a.667.667 0 1 0 0 1.334H14a.667.667 0 0 0 0-1.334m-6 5.334a.667.667 0 0 0-.667.666V14a.667.667 0 1 0 1.334 0v-.667A.667.667 0 0 0 8 12.667m4.24-1.334a.666.666 0 0 0-.906.907l.473.473a.667.667 0 0 0 .94 0 .667.667 0 0 0 0-.94zm-4.24-7A3.667 3.667 0 1 0 11.667 8 3.673 3.673 0 0 0 8 4.333m0 6a2.333 2.333 0 1 1 0-4.666 2.333 2.333 0 0 1 0 4.666"
  }
) }), P = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M3.807 4.193a.7.7 0 0 0-.22-.14.67.67 0 0 0-.507 0 .7.7 0 0 0-.22.14L1.527 5.527a.67.67 0 1 0 .946.946l.194-.2v5.06a.667.667 0 1 0 1.333 0v-5.06l.193.2a.667.667 0 0 0 1.093-.217.67.67 0 0 0-.146-.73zm3.526 1.14H14A.667.667 0 0 0 14 4H7.333a.667.667 0 0 0 0 1.333M14 10.667H7.333a.667.667 0 1 0 0 1.333H14a.667.667 0 1 0 0-1.333m0-3.334H7.333a.667.667 0 1 0 0 1.334H14a.667.667 0 0 0 0-1.334"
  }
) }), j = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M6 5.167C6 3.334 4.28 2.16 4.207 2.114a.67.67 0 0 0-.747 0c-.073.053-1.793 1.22-1.793 3.053a2.167 2.167 0 0 0 4.333 0M3.833 6A.833.833 0 0 1 3 5.167a2.44 2.44 0 0 1 .833-1.633c.483.413.782 1 .834 1.633A.833.833 0 0 1 3.833 6m4.04.78a.67.67 0 0 0-.746 0c-.114.08-2.794 1.934-2.794 4.72a3.167 3.167 0 0 0 6.334 0c0-2.833-2.667-4.646-2.794-4.72M7.5 13.334A1.834 1.834 0 0 1 5.667 11.5c0-1.54 1.206-2.78 1.84-3.333.626.527 1.826 1.753 1.826 3.333A1.834 1.834 0 0 1 7.5 13.334m4.54-11.887a.67.67 0 0 0-.747 0C11.2 1.514 9 3.034 9 5.334a2.667 2.667 0 1 0 5.333 0c0-2.327-2.2-3.827-2.293-3.887m-.373 5.22a1.333 1.333 0 0 1-1.334-1.333 3.63 3.63 0 0 1 1.334-2.48A3.6 3.6 0 0 1 13 5.334a1.333 1.333 0 0 1-1.333 1.333"
  }
) }), $ = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M4.666 1.834h4a.167.167 0 0 1 .167.167v3.833h2.5a.17.17 0 0 1 .167.167v7.833H14a.166.166 0 0 1 0 .333H2a.17.17 0 0 1-.167-.166.17.17 0 0 1 .167-.167h2.5V2.001a.167.167 0 0 1 .166-.167Zm.167 12H8.5V2.167H4.833zm4 0h2.333V6.167H8.833z"
  }
) }), I = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M2 5.333h12A.667.667 0 1 0 14 4H2a.667.667 0 0 0 0 1.333m12 5.334H2A.667.667 0 1 0 2 12h12a.666.666 0 1 0 0-1.333m0-3.334H2a.667.667 0 0 0 0 1.334h12a.667.667 0 1 0 0-1.334"
  }
) }), U = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71 8.46 9.17a1 1 0 1 0-1.41 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 .219-1.095 1 1 0 0 0-.22-.325Z"
  }
) }), O = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 17 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M13.167 13.333H3.832a.666.666 0 1 0 0 1.333h9.333a.667.667 0 1 0 0-1.333m-5.14-1.527q.096.092.22.14a.63.63 0 0 0 .506 0 .7.7 0 0 0 .22-.14L11.64 9.14a.67.67 0 1 0-.947-.947L9.166 9.726V2a.667.667 0 1 0-1.333 0v7.726L6.306 8.193a.67.67 0 1 0-.946.947z"
  }
) }), G = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 7 9", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "#40A9FF",
    d: "M3.072 0C2.028 1.467 0 4.595 0 5.928a3.072 3.072 0 1 0 6.145 0c0-1.333-2.028-4.461-3.073-5.928m0 8.386A2.46 2.46 0 0 1 .614 5.928a.307.307 0 0 1 .615 0A1.845 1.845 0 0 0 3.072 7.77a.307.307 0 0 1 0 .615Z"
  }
) }), X = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 8 13", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "#40A9FF",
    d: "M1.75 0C1.116 1.119 0 3.245 0 4a1.75 1.75 0 0 0 3.5 0c0-.754-1.116-2.88-1.75-4m0 5.25A1.25 1.25 0 0 1 .5 4 .25.25 0 0 1 1 4a.75.75 0 0 0 .75.75.25.25 0 0 1 0 .5m3.75-.323C4.65 6.12 3 8.666 3 9.75a2.5 2.5 0 0 0 5 0c0-1.084-1.65-3.63-2.5-4.823m0 6.823a2 2 0 0 1-2-2 .25.25 0 1 1 .5 0 1.5 1.5 0 0 0 1.5 1.5.25.25 0 1 1 0 .5"
  }
) }), Y = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 13 14", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "#40A9FF",
    d: "M3.25 3.947C2.506 5.06 0 8.93 0 10.5a3.25 3.25 0 1 0 6.5 0c0-1.569-2.506-5.439-3.25-6.553m0 9.303A2.753 2.753 0 0 1 .5 10.5a.25.25 0 1 1 .5 0 2.25 2.25 0 0 0 2.25 2.25.25.25 0 0 1 0 .5M7.75 0C7.116 1.119 6 3.245 6 4a1.75 1.75 0 1 0 3.5 0c0-.754-1.116-2.88-1.75-4m0 5.25A1.25 1.25 0 0 1 6.5 4 .25.25 0 0 1 7 4a.75.75 0 0 0 .75.75.25.25 0 0 1 0 .5m2.75-.323C9.65 6.12 8 8.666 8 9.75a2.5 2.5 0 0 0 5 0c0-1.084-1.65-3.63-2.5-4.823m0 6.823a2 2 0 0 1-2-2 .25.25 0 1 1 .5 0 1.5 1.5 0 0 0 1.5 1.5.25.25 0 1 1 0 .5"
  }
) }), J = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M14.667 4.825a.67.67 0 0 0-.194-.473l-2.826-2.827a.67.67 0 0 0-.474-.193.67.67 0 0 0-.473.193L8.813 3.412l-7.286 7.287a.67.67 0 0 0-.194.473v2.827a.667.667 0 0 0 .667.666h2.827a.67.67 0 0 0 .506-.193l7.247-7.287 1.893-1.853a.8.8 0 0 0 .147-.22.7.7 0 0 0 0-.16.5.5 0 0 0 0-.093zM4.553 13.332H2.667v-1.887l6.62-6.62 1.886 1.887zm7.56-7.56-1.886-1.887.946-.94 1.88 1.88z"
  }
) }), K = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M5 18h4.24a1 1 0 0 0 .71-.29l6.92-6.93L19.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71V17a1 1 0 0 0 1 1m9.76-13.59 2.83 2.83-1.42 1.42-2.83-2.83zM6 13.17l5.93-5.93 2.83 2.83L8.83 16H6zM21 20H3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2"
  }
) }), Q = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3m-.41 2-5.88 5.88a1 1 0 0 1-1.42 0L5.41 6zM20 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7.41l5.88 5.88a3 3 0 0 0 4.24 0L20 7.41z"
  }
) }), a0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.06 5.94a1.5 1.5 0 1 0-2.12 2.12L9.878 12l-3.94 3.94a1.5 1.5 0 0 0 2.122 2.12L12 14.122l3.94 3.94a1.5 1.5 0 0 0 2.12-2.122L14.122 12l3.94-3.94a1.5 1.5 0 0 0-2.122-2.12L12 9.878z",
    clipRule: "evenodd"
  }
) }), l0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M4 12a1 1 0 0 0 1 1h7.59l-2.3 2.29a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.219l4-4a1 1 0 0 0 .21-.33 1 1 0 0 0 0-.76 1 1 0 0 0-.21-.33l-4-4a1.003 1.003 0 1 0-1.42 1.42l2.3 2.29H5a1 1 0 0 0-1 1M17 2H7a3 3 0 0 0-3 3v3a1 1 0 0 0 2 0V5a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-3a1 1 0 1 0-2 0v3a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3"
  }
) }), o0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "m6.194 8.86-3.527 3.533v-1.06a.667.667 0 1 0-1.333 0V14q.001.132.053.253a.67.67 0 0 0 .613.414h2.667a.667.667 0 0 0 0-1.334h-1.06L7.14 9.807a.67.67 0 0 0-.946-.947M3.607 2.667h1.06a.667.667 0 1 0 0-1.334H2A.667.667 0 0 0 1.333 2v2.667a.667.667 0 1 0 1.334 0v-1.06L6.194 7.14a.667.667 0 0 0 1.092-.217.67.67 0 0 0-.146-.73zm10.393 8a.667.667 0 0 0-.666.666v1.06L9.807 8.86a.67.67 0 1 0-.947.947l3.534 3.526h-1.06a.667.667 0 1 0 0 1.334H14a.667.667 0 0 0 .667-.667v-2.667a.667.667 0 0 0-.667-.666m.614-8.92A.67.67 0 0 0 14 1.333h-2.666a.667.667 0 1 0 0 1.334h1.06L8.86 6.193a.667.667 0 0 0 .217 1.093.67.67 0 0 0 .73-.146l3.527-3.533v1.06a.666.666 0 1 0 1.333 0V2a.7.7 0 0 0-.053-.253"
  }
) }), e0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m6.444 2 7.112 16M2 14.444 10 10m-3.733 8h7.466c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81V6.266c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.165C15.974 2 15.227 2 13.734 2H6.266c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166C2 4.026 2 4.773 2 6.266v7.467c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291"
  }
) }), n0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 2.667A.667.667 0 0 0 2 4h3.013l.267.334a3.33 3.33 0 0 0-2.613 1.333l-1.2 1.6a.67.67 0 0 0-.134.4V11c0 .368.299.667.667.667h.667A2 2 0 0 0 6.639 12h1.389a2 2 0 1 0 3.924-.772l.91.91a.67.67 0 0 0 .471.196H14A.667.667 0 0 0 14 11h-.39L12 9.39V7.13l1.118-2.795H14A.667.667 0 0 0 14 3H8.667A.667.667 0 0 0 8 3.667v.667H6.987L5.854 2.917a.67.67 0 0 0-.52-.25zm6.268 8a2 2 0 0 1 2.41-.882 1 1 0 0 1-.011-.118v-2H8.749l-2.587.647a.7.7 0 0 1-.162.02H2.667v2h.509a2 2 0 0 1 3.223.333zm-2.935 1a.667.667 0 1 0-1.333 0 .667.667 0 0 0 1.333 0M5.918 7H3.333l.4-.533a2 2 0 0 1 1.6-.8H8v.813zm3.415-.666v-2h2.349l-.8 2zM10 11a.667.667 0 1 0 0 1.334A.667.667 0 0 0 10 11",
    clipRule: "evenodd"
  }
) }), t0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 17 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "#52C41A",
    d: "M15.114 4.413A.67.67 0 0 0 14.5 4h-3.333a.667.667 0 1 0 0 1.333h1.726L9.168 9.06l-2.194-2.2a.667.667 0 0 0-.946 0l-4 4a.667.667 0 0 0 .217 1.093.67.67 0 0 0 .73-.146L6.5 8.273l2.193 2.2a.667.667 0 0 0 .947 0l4.194-4.2V8a.667.667 0 1 0 1.333 0V4.667a.7.7 0 0 0-.053-.254"
  }
) }), r0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "#f5222d",
    d: "M14.613 11.59a.67.67 0 0 1-.613.414h-3.333a.666.666 0 1 1 0-1.333h1.726L8.667 6.944l-2.194 2.2a.667.667 0 0 1-.946 0l-4-4a.666.666 0 0 1 .217-1.093.67.67 0 0 1 .73.146L6 7.731l2.193-2.2a.667.667 0 0 1 .947 0l4.193 4.2V8.004a.667.667 0 0 1 1.334 0v3.333a.7.7 0 0 1-.054.254Z"
  }
) }), c0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8 7.334a.667.667 0 0 0-.667.667v2.666a.667.667 0 1 0 1.334 0V8.001A.667.667 0 0 0 8 7.334m.253-2.613a.67.67 0 0 0-.506 0 .7.7 0 0 0-.22.14.8.8 0 0 0-.14.22.67.67 0 0 0 .14.727.8.8 0 0 0 .22.14.667.667 0 0 0 .92-.614.7.7 0 0 0-.194-.473.7.7 0 0 0-.22-.14M8 1.334a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.334m0 12A5.334 5.334 0 1 1 8 2.667a5.334 5.334 0 0 1 0 10.667"
  }
) }), v0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M17 11H9.41l3.3-3.29a1.004 1.004 0 0 0-1.42-1.42l-5 5a1 1 0 0 0-.21.33 1 1 0 0 0 0 .76 1 1 0 0 0 .21.33l5 5a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095L9.41 13H17a1 1 0 0 0 0-2"
  }
) }), i0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M3.71 16.29a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21 1 1 0 0 0-.21.33 1 1 0 0 0 .21 1.09q.147.134.33.21a.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21 1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.33M7 8h14a1 1 0 1 0 0-2H7a1 1 0 0 0 0 2m-3.29 3.29a1 1 0 0 0-1.09-.21 1.2 1.2 0 0 0-.33.21 1 1 0 0 0-.21.33.94.94 0 0 0 0 .76q.076.183.21.33.147.133.33.21a.94.94 0 0 0 .76 0 1.2 1.2 0 0 0 .33-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1 1 0 0 0-.21-.33M21 11H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2M3.71 6.29a1 1 0 0 0-.33-.21 1 1 0 0 0-1.09.21 1.2 1.2 0 0 0-.21.33.94.94 0 0 0 0 .76q.076.183.21.33.147.133.33.21a1 1 0 0 0 1.09-.21 1.2 1.2 0 0 0 .21-.33.94.94 0 0 0 0-.76 1.2 1.2 0 0 0-.21-.33M21 16H7a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2"
  }
) }), s0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M12 13a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m5-4V7A5 5 0 0 0 7 7v2a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3M9 7a3 3 0 1 1 6 0v2H9zm9 12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1z"
  }
) }), h0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "m21.32 5.05-6-2h-.07a.7.7 0 0 0-.14 0h-.43L9 5 3.32 3.05a1 1 0 0 0-.9.14A1 1 0 0 0 2 4v14a1 1 0 0 0 .68.95l6 2a1 1 0 0 0 .62 0l5.7-1.9L20.68 21q.16.021.32 0a.94.94 0 0 0 .58-.19A1 1 0 0 0 22 20V6a1 1 0 0 0-.68-.95M8 18.61l-4-1.33V5.39l4 1.33zm6-1.33-4 1.33V6.72l4-1.33zm6 1.33-4-1.33V5.39l4 1.33z"
  }
) }), w0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.073 6 13.854 8M3.073 6a8 8 0 0 0 2.928 10.927M3.073 6.001a8 8 0 0 1 10.926-2.928m2.928 10.926a8 8 0 0 1-10.926 2.928m10.926-2.928a8 8 0 0 0-2.928-10.926m0 0C14.637 5.97 14.2 9 12.771 11.6A12.24 12.24 0 0 1 6 16.927m7.998-13.854A12.24 12.24 0 0 0 7.23 8.4a12.24 12.24 0 0 0-1.228 8.527"
  }
) }), g0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a("path", { fill: "currentColor", d: "M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" }) }), d0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8 4.667A1.333 1.333 0 1 0 8 2a1.333 1.333 0 0 0 0 2.667m0 6.666A1.333 1.333 0 1 0 8 14a1.333 1.333 0 0 0 0-2.667m0-4.666a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666"
  }
) }), m0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M11.333 8.001a1.333 1.333 0 1 0 2.667 0 1.333 1.333 0 0 0-2.667 0m-6.666 0a1.333 1.333 0 1 0-2.667 0 1.333 1.333 0 0 0 2.667 0m4.666 0a1.333 1.333 0 1 0-2.666 0 1.333 1.333 0 0 0 2.666 0"
  }
) }), p0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 17 17", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.18,
    d: "M15.549.106a.89.89 0 0 1 .65 1.225l-6.172 14.4a.89.89 0 0 1-.817.539h-.001a.88.88 0 0 1-.585-.219.9.9 0 0 1-.283-.47L6.924 9.436.78 8.019a.89.89 0 0 1-.15-1.686L15.03.162a.9.9 0 0 1 .519-.056ZM3.835 6.896l4.03.93a.89.89 0 0 1 .669.669l.93 4.03 4.221-9.85z"
  }
) }), f0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M15.54 11.29 9.88 5.64a1 1 0 1 0-1.42 1.41l4.95 5L8.46 17a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l5.66-5.65a1 1 0 0 0 0-1.47"
  }
) }), u0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M14.427 8.667a.67.67 0 0 0-.7-.094 5.4 5.4 0 0 1-2.247.487 5.433 5.433 0 0 1-5.427-5.4q.005-.677.167-1.333a.667.667 0 0 0-.887-.754 6.76 6.76 0 1 0 9.334 7.794.67.67 0 0 0-.24-.7m-6.334 4.46A5.426 5.426 0 0 1 4.72 3.48v.18a6.767 6.767 0 0 0 8.16 6.613 5.41 5.41 0 0 1-4.787 2.88z"
  }
) }), x0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M10.667 9.333H5.333a.667.667 0 0 0 0 1.333h5.334a.667.667 0 0 0 0-1.333m0-2.667h-4a.667.667 0 0 0 0 1.334h4a.667.667 0 0 0 0-1.334m2.666-4h-2V2A.667.667 0 1 0 10 2v.666H8.667V2a.667.667 0 1 0-1.334 0v.666H6V2a.667.667 0 0 0-1.333 0v.666h-2A.667.667 0 0 0 2 3.333v9.333a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3.333a.666.666 0 0 0-.667-.667m-.666 10a.667.667 0 0 1-.667.667H4a.666.666 0 0 1-.667-.667V4h1.334v.666a.667.667 0 1 0 1.333 0V4h1.333v.666a.667.667 0 0 0 1.334 0V4H10v.666a.666.666 0 1 0 1.333 0V4h1.334z"
  }
) }), M0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8 1.332a6.67 6.67 0 0 0-4.587 1.847v-1.18a.667.667 0 0 0-1.333 0v3a.667.667 0 0 0 .666.666h3a.667.667 0 1 0 0-1.333h-1.6a5.333 5.333 0 1 1-1.48 3.667.667.667 0 0 0-1.333 0A6.667 6.667 0 1 0 8 1.332m0 4a.667.667 0 0 0-.667.667v2A.667.667 0 0 0 8 8.665h1.333a.667.667 0 1 0 0-1.333h-.667V5.999A.667.667 0 0 0 8 5.332"
  }
) }), C0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 33", ...l, children: [
  /* @__PURE__ */ a("path", { fill: "#fff", d: "M11 32a1 1 0 1 0 2 0zm0-20v20h2V12z" }),
  /* @__PURE__ */ a("circle", { cx: 12, cy: 12, r: 11, fill: "#32D583", stroke: "#fff", strokeWidth: 2 })
] }), V0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M7.333 7.933v3.4a.667.667 0 1 0 1.334 0v-3.4a3.333 3.333 0 1 0-1.334 0M8 2.667a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.807 6.946a.681.681 0 0 0-.28 1.334c1.513.3 2.14.84 2.14 1.053 0 .387-1.634 1.333-4.667 1.333S3.333 12.387 3.333 12c0-.213.627-.753 2.14-1.08a.681.681 0 0 0-.28-1.333C3.167 10.053 2 10.927 2 12c0 1.753 3.02 2.667 6 2.667s6-.914 6-2.667c0-1.073-1.167-1.947-3.193-2.387"
  }
) }), H0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.764 2.11a.83.83 0 0 1 .776-.442c4.54.216 6.74 1.87 7.418 3.902.323.97.258 1.934.016 2.691-.121.38-.293.728-.503 1.012l-.009.012c.2.324.38.694.538 1.08.285-.69.64-1.333 1.044-1.753l-.051-.148a3.45 3.45 0 0 1 .013-2.111c.535-1.616 2.258-2.858 5.621-3.019a.833.833 0 0 1 .708 1.331c-.236.316-.844 1.378-1.063 2.698-.203 1.22-.938 1.978-1.78 2.348-.789.347-1.676.362-2.33.15-.26.32-.58.946-.85 1.757-.295.882-.478 1.832-.478 2.549l-.004.081c.882.156 1.785.578 2.637 1.365a4.4 4.4 0 0 1 1.985-.404c1.088.045 2.258.573 2.822 1.982a.833.833 0 0 1-1.547.619c-.27-.675-.766-.912-1.345-.936-.645-.027-1.271.23-1.515.433a.833.833 0 0 1-1.156-.087c-1.142-1.284-2.31-1.494-3.252-1.327-1.015.181-1.813.808-2.099 1.236a.833.833 0 0 1-1.135.244c-1.108-.692-1.837-.548-2.26-.33-.237.122-.42.29-.538.437-.053.066-.086.12-.104.154a.834.834 0 0 1-1.656-.134c0-.248.093-.466.156-.593.076-.155.18-.314.303-.468a3.4 3.4 0 0 1 1.076-.878c.856-.44 1.98-.549 3.272.053a5.3 5.3 0 0 1 2.693-1.362h.004a1 1 0 0 1-.004-.085c0-.717-.184-1.667-.478-2.55-.215-.643-.461-1.17-.684-1.52a4.5 4.5 0 0 1-2.401-.323c-1.067-.467-2-1.416-2.259-2.97C3.037 4.953 2.182 3.464 1.834 3a.83.83 0 0 1-.07-.89m2.26 1.37c.386.818.769 1.872.965 3.05.158.946.683 1.454 1.283 1.717.63.276 1.335.272 1.766.14a.6.6 0 0 0 .093-.105c.086-.116.18-.295.255-.527a2.7 2.7 0 0 0-.01-1.658c-.315-.945-1.358-2.171-4.352-2.616m-.717 14.188.005-.012zm11.32-10.577a8.8 8.8 0 0 1 .554-1.915c-1.814.362-2.411 1.153-2.593 1.701a1.8 1.8 0 0 0-.006 1.083c.048.152.107.261.154.324l.007.01c.268.066.694.06 1.077-.108.375-.165.705-.48.807-1.095",
    clipRule: "evenodd"
  }
) }), A0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.719 1.613c.493.055.883.444.938.938a3.83 3.83 0 0 1-4.228 4.228 1.06 1.06 0 0 1-.938-.938 3.83 3.83 0 0 1 4.228-4.228M2.8 5.469a2.496 2.496 0 0 1 2.546-2.546A2.496 2.496 0 0 1 2.8 5.469m11.567 2.104.047-.554a2 2 0 0 0-2.163-2.164l-2.197.189a6 6 0 0 0-5.466 5.465l-.128 1.497-.055.077.046.032-.051.591a2 2 0 0 0 2.163 2.164l2.198-.188a6 6 0 0 0 5.465-5.466l.14-1.628.007-.01zm-1.28-.668a.667.667 0 0 0-.722-.721l-2.197.188a4.67 4.67 0 0 0-4.251 4.251l-.003.033q.268-.191.55-.366c.86-.533 1.888-.994 2.837-1.12 1.48-.198 2.297-.577 2.813-.97.425-.324.677-.675.953-1.077zm-.21 2.389c-.746.555-1.793.983-3.4 1.197-.69.092-1.534.451-2.31.933-.594.367-1.09.77-1.415 1.115l-.024.281a.667.667 0 0 0 .721.721l2.198-.188a4.67 4.67 0 0 0 4.23-4.06Z",
    clipRule: "evenodd"
  }
) }), S0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.952 5.954V4.9c0-.35.284-.633.633-.633h11.823c.35 0 .633.283.633.633v1.055h1.056c.35 0 .633.284.633.634V18.41c0 .35-.283.633-.633.633h-1.056V20.1c0 .35-.283.633-.633.633H6.585a.634.634 0 0 1-.633-.633v-1.056H4.897a.634.634 0 0 1-.634-.633V6.588c0-.35.284-.634.634-.634zM5.53 17.777h.633a1.06 1.06 0 0 1 1.056 1.055v.633h10.556v-.633a1.06 1.06 0 0 1 1.055-1.055h.634V7.22h-.634a1.06 1.06 0 0 1-1.055-1.055v-.634H7.219v.634A1.06 1.06 0 0 1 6.163 7.22H5.53z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20.943 3C21.526 3 22 3.473 22 4.056v2.11c0 .583-.473 1.056-1.056 1.056h-2.111a1.056 1.056 0 0 1-1.056-1.055V4.056c0-.583.473-1.056 1.056-1.056zm0 14.777c.583 0 1.056.473 1.056 1.056v2.111c0 .583-.473 1.056-1.056 1.056h-2.111a1.056 1.056 0 0 1-1.056-1.056v-2.111c0-.583.473-1.056 1.056-1.056zM6.167 3c.582 0 1.055.473 1.055 1.056v2.11c0 .583-.473 1.056-1.055 1.056H4.056A1.056 1.056 0 0 1 3 6.167V4.056C3 3.473 3.473 3 4.056 3zm0 14.777c.582 0 1.055.473 1.055 1.056v2.111c0 .583-.473 1.056-1.055 1.056H4.056A1.056 1.056 0 0 1 3 20.944v-2.111c0-.583.473-1.056 1.056-1.056z",
      clipRule: "evenodd"
    }
  )
] }), B0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0s.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3s-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6q0-.15 0 0"
  }
) }), L0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M13.333 4h-2.666v-.667a2 2 0 0 0-2-2H7.333a2 2 0 0 0-2 2V4H2.667a.667.667 0 0 0 0 1.334h.666v7.333a2 2 0 0 0 2 2h5.334a2 2 0 0 0 2-2V5.334h.666a.667.667 0 1 0 0-1.334m-6.666-.667a.667.667 0 0 1 .666-.666h1.334a.667.667 0 0 1 .666.667V4H6.667zm4.666 9.334a.667.667 0 0 1-.666.667H5.333a.666.666 0 0 1-.666-.667V5.334h6.666z"
  }
) }), z0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M21.71 20.29 18 16.61A9 9 0 1 0 16.61 18l3.68 3.68a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.39M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14"
  }
) }), k0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M16.95 7.767 5.283 1.934a2.5 2.5 0 0 0-3.4 3.25l2 4.475a.88.88 0 0 1 0 .683l-2 4.475a2.5 2.5 0 0 0 2.284 3.517c.39-.004.774-.095 1.125-.267l11.666-5.833a2.5 2.5 0 0 0 0-4.467zm-.742 2.975L4.542 16.575a.833.833 0 0 1-1.125-1.083l1.991-4.475q.039-.09.067-.183h5.742a.833.833 0 0 0 0-1.667H5.475a2 2 0 0 0-.067-.183L3.417 4.509a.833.833 0 0 1 1.125-1.084L16.208 9.26a.833.833 0 0 1 0 1.483Z"
  }
) }), y0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M13.267 8.44a.67.67 0 0 1 0-.88l.853-.96a.67.67 0 0 0 .08-.78l-1.333-2.307a.67.67 0 0 0-.714-.32l-1.253.254a.67.67 0 0 1-.767-.44l-.406-1.22a.67.67 0 0 0-.634-.454H6.427a.67.67 0 0 0-.667.454l-.373 1.22a.67.67 0 0 1-.767.44l-1.287-.254a.67.67 0 0 0-.666.32L1.333 5.82a.67.67 0 0 0 .067.78l.847.96a.67.67 0 0 1 0 .88L1.4 9.4a.67.67 0 0 0-.067.78l1.334 2.307a.67.67 0 0 0 .713.32l1.253-.254a.67.67 0 0 1 .767.44l.407 1.22a.67.67 0 0 0 .666.454H9.14a.67.67 0 0 0 .633-.454l.407-1.22a.67.67 0 0 1 .767-.44l1.253.254a.67.67 0 0 0 .713-.32l1.334-2.307a.67.67 0 0 0-.08-.78zm-.994.893.534.6-.854 1.48-.786-.16a2 2 0 0 0-2.3 1.334l-.254.746H6.907l-.24-.76a2 2 0 0 0-2.3-1.333l-.787.16-.867-1.473.534-.6a2 2 0 0 0 0-2.667l-.534-.6.854-1.467.786.16a2 2 0 0 0 2.3-1.333l.254-.753h1.706l.254.76a2 2 0 0 0 2.3 1.333l.786-.16.854 1.48-.534.6a2 2 0 0 0 0 2.653m-4.513-4a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334m0 4a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666"
  }
) }), R0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.892 2.093a1 1 0 0 1 .8-.368c.27.007.475.142.578.216.11.078.235.185.36.292l.018.015 5.647 4.84.013.012c.07.06.15.129.216.195.073.075.177.195.238.367a1 1 0 0 1 0 .676 1 1 0 0 1-.238.366c-.066.067-.146.136-.216.196l-.013.011-5.666 4.856c-.124.106-.249.214-.359.292-.103.073-.307.21-.579.216a1 1 0 0 1-.8-.368 1.05 1.05 0 0 1-.212-.58c-.012-.135-.012-.3-.012-.463v-2.067a6.93 6.93 0 0 0-4.154 2.404.667.667 0 0 1-1.18-.426v-.408a7.11 7.11 0 0 1 5.334-6.881V3.135c0-.163 0-.328.012-.462.011-.126.041-.37.213-.58M8 3.449v2.574c0 .324-.233.6-.552.657a5.78 5.78 0 0 0-4.633 4.392 8.27 8.27 0 0 1 4.473-1.69.667.667 0 0 1 .712.665v2.503L13.309 8z",
    clipRule: "evenodd"
  }
) }), q0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M15.84 2.16a2.31 2.31 0 0 0-3.18 0l-1.815 1.807a2.25 2.25 0 0 0-.427 2.558L8.805 8.137l-1.5-1.5a2.25 2.25 0 0 0-3.75.878l-1.995 6a2.25 2.25 0 0 0 .54 2.302 2.25 2.25 0 0 0 1.65.683c.255.005.51-.036.75-.12l6-1.995a2.25 2.25 0 0 0 .877-3.75l-1.5-1.5 1.613-1.613a2.25 2.25 0 0 0 2.558-.427l1.807-1.815a2.25 2.25 0 0 0-.015-3.12m-5.565 9.562a.75.75 0 0 1-.3 1.238L3.99 15a.75.75 0 0 1-.938-.938l2.003-6A.75.75 0 0 1 5.58 7.5a1 1 0 0 1 .172 0 .75.75 0 0 1 .525.217l1.5 1.5-.652.645a.75.75 0 0 0 .244 1.23.75.75 0 0 0 .821-.165l.645-.652zm4.5-7.44L12.967 6.09a.75.75 0 0 1-1.275-.533.75.75 0 0 1 .218-.525l1.807-1.815a.75.75 0 0 1 1.065 0 .75.75 0 0 1 0 1.065z"
  }
) }), _0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 9", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.25,
      d: "M3.106 1.117a4.79 4.79 0 0 0-.001 6.766.417.417 0 0 0 .589-.589 3.957 3.957 0 0 1 0-5.588.416.416 0 0 0-.588-.589Z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.25,
      d: "M4.34 2.353a3.04 3.04 0 0 0 0 4.294.417.417 0 0 0 .589-.589 2.207 2.207 0 0 1 0-3.117.416.416 0 0 0-.588-.588ZM11.694 1.117a4.79 4.79 0 0 1 0 6.766.417.417 0 0 1-.59-.589 3.957 3.957 0 0 0 .002-5.588.416.416 0 0 1 .588-.589Z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.25,
      d: "M10.46 2.353a3.04 3.04 0 0 1 0 4.294.417.417 0 0 1-.589-.589c.86-.86.86-2.257 0-3.117a.416.416 0 0 1 .588-.588Z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 0.2,
      d: "M7.4 1.4A.6.6 0 0 1 8 2v5.5a.6.6 0 1 1-1.2 0V2a.6.6 0 0 1 .6-.6Z"
    }
  )
] }), W0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8.667 10.667H2A.667.667 0 1 0 2 12h6.667a.666.666 0 1 0 0-1.333M2 5.333h12A.667.667 0 0 0 14 4H2a.667.667 0 0 0 0 1.333m12 2H2a.667.667 0 1 0 0 1.334h12a.667.667 0 0 0 0-1.334"
  }
) }), F0 = (l) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-icon": "caret-up",
    viewBox: "0 0 1024 1024",
    ...l,
    children: /* @__PURE__ */ a("path", { d: "M858.9 689 530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35" })
  }
), b0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8.474 4.193a.7.7 0 0 0-.22-.14.67.67 0 0 0-.507 0 .7.7 0 0 0-.22.14L4.86 6.86a.67.67 0 0 0 .947.946l1.527-1.533V14a.667.667 0 1 0 1.333 0V6.273l1.527 1.533a.666.666 0 0 0 .946 0 .667.667 0 0 0 0-.946zm4.193-2.86H3.334a.667.667 0 0 0 0 1.333h9.333a.667.667 0 1 0 0-1.333"
  }
) }), Z0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "url(#stageAi_svg__a)",
      d: "M8.473 4.194a.7.7 0 0 0-.22-.14.67.67 0 0 0-.506 0 .7.7 0 0 0-.22.14L4.86 6.861a.67.67 0 1 0 .947.946l1.526-1.533v7.727a.667.667 0 0 0 1.334 0V6.274l1.526 1.533a.666.666 0 0 0 1.093-.217.67.67 0 0 0-.146-.73zm4.194-2.86H3.333a.667.667 0 1 0 0 1.333h9.334a.667.667 0 1 0 0-1.333"
    }
  ),
  /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ o("linearGradient", { id: "stageAi_svg__a", x1: 8, x2: 8, y1: 1.334, y2: 14.667, gradientUnits: "userSpaceOnUse", children: [
    /* @__PURE__ */ a("stop", { stopColor: "#FF9945" }),
    /* @__PURE__ */ a("stop", { offset: 0.49, stopColor: "#FF6D4B" }),
    /* @__PURE__ */ a("stop", { offset: 1, stopColor: "#FF504F" })
  ] }) })
] }), D0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M2 13.167h8a.166.166 0 0 1 .166.166.17.17 0 0 1-.166.167H2a.17.17 0 0 1-.167-.167.167.167 0 0 1 .167-.166ZM2 10.5h12a.167.167 0 0 1 0 .333H2a.17.17 0 0 1-.167-.166A.17.17 0 0 1 2 10.5Zm0-2.667h12a.167.167 0 0 1 0 .334H2A.17.17 0 0 1 1.833 8 .167.167 0 0 1 2 7.833Zm0-2.666h12a.166.166 0 0 1 .117.284A.17.17 0 0 1 14 5.5H2a.167.167 0 0 1-.167-.167A.166.166 0 0 1 2 5.167ZM2 2.5h12a.167.167 0 0 1 0 .333H2a.167.167 0 0 1-.167-.166A.167.167 0 0 1 2 2.5Z"
  }
) }), T0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8.2 8.145a3.28 3.28 0 0 0 1.133-2.48 3.333 3.333 0 0 0-6.667 0 3.28 3.28 0 0 0 1.133 2.48A5.33 5.33 0 0 0 .666 13a.667.667 0 1 0 1.333 0 4 4 0 1 1 8 0 .667.667 0 0 0 1.334 0 5.33 5.33 0 0 0-3.134-4.854M6 7.665a2 2 0 1 1 0-4 2 2 0 0 1 0 4m6.494.214a3.334 3.334 0 0 0-2.494-5.547.667.667 0 0 0 0 1.333 2 2 0 0 1 2 2 2 2 0 0 1-1 1.727.667.667 0 0 0-.033 1.133l.26.174.087.046A4.67 4.67 0 0 1 13.979 13a.667.667 0 0 0 1.334 0 6 6 0 0 0-2.82-5.12"
  }
) }), N0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8.667 10.187v-4.52a.667.667 0 1 0-1.334 0v4.52a1.33 1.33 0 0 0-.666 1.146 1.333 1.333 0 0 0 2.666 0 1.33 1.33 0 0 0-.666-1.146M11 8.667v-5a3 3 0 0 0-6 0v5a4 4 0 0 0 2.14 6.553q.425.096.86.113a4 4 0 0 0 3-6.667ZM9.667 13.38a2.673 2.673 0 1 1-3.547-4 .67.67 0 0 0 .2-.474v-5.24a1.667 1.667 0 1 1 3.333 0V8.96a.67.67 0 0 0 .2.473 2.666 2.666 0 0 1-.186 4z"
  }
) }), E0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M11 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-14a1 1 0 0 0-1 1v4.42l-2.1 1.21a1 1 0 0 0 .5 1.87 1 1 0 0 0 .5-.13l2.6-1.5.09-.09.16-.13a1 1 0 0 0 .1-.16 1 1 0 0 0 .08-.17.7.7 0 0 0 .05-.2L12 12V7a1 1 0 0 0-1-1"
  }
) }), P0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334Zm0 3.334c.177 0 .346.07.471.195l2.667 2.667a.667.667 0 0 1-.943.943L8.667 6.943v3.724a.667.667 0 1 1-1.334 0V6.943L5.805 8.472a.667.667 0 1 1-.943-.943l2.667-2.667A.67.67 0 0 1 8 4.667",
    clipRule: "evenodd"
  }
) }), j0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: [
  /* @__PURE__ */ a("path", { fill: "currentColor", d: "M4.667 11.333a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333" }),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1.333 2a.667.667 0 0 0 0 1.333H2v4.352a4 4 0 1 0 6.611 3.648h1.614a2.333 2.333 0 1 0 3.794-.614l1.28-3.842A.667.667 0 0 0 14.667 6h-2V4.667a.667.667 0 0 0-1.334 0V6H9.836l-.952-2.667h.45a.667.667 0 1 0 0-1.333zm10 10.333a1 1 0 1 1 2 0 1 1 0 0 1-2 0M12.853 10H8.61a4 4 0 0 0-5.278-3.106v-3.56h4.164L8.692 6.85a.67.67 0 0 0 .641.483h4.409zM3.078 8.525a2.667 2.667 0 1 1 3.177 4.284 2.667 2.667 0 0 1-3.177-4.284",
      clipRule: "evenodd"
    }
  )
] }), $0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M8.71 7.71 11 5.41V15a1 1 0 0 0 2 0V5.41l2.29 2.3a1 1 0 0 0 1.639-.326 1 1 0 0 0-.219-1.094l-4-4a1 1 0 0 0-.33-.21 1 1 0 0 0-.76 0 1 1 0 0 0-.33.21l-4 4a1.004 1.004 0 1 0 1.42 1.42M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6a1 1 0 1 0-2 0v6a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1"
  }
) }), I0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m0 5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  }
) }), U0 = (l) => /* @__PURE__ */ a("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...l, children: /* @__PURE__ */ a(
  "path",
  {
    fill: "currentColor",
    d: "M1.813 5.1q.196.057.374.16a2.67 2.67 0 0 0 2.733 0 1.73 1.73 0 0 1 1.707 0 2.77 2.77 0 0 0 2.746 0 1.73 1.73 0 0 1 1.707 0c.422.242.9.37 1.387.373.47 0 .93-.13 1.333-.373q.178-.102.373-.16a.667.667 0 0 0-.373-1.28 3 3 0 0 0-.667.3 1.39 1.39 0 0 1-1.4 0 3.09 3.09 0 0 0-3.026 0 1.41 1.41 0 0 1-1.414 0 3.09 3.09 0 0 0-3.026 0 1.39 1.39 0 0 1-1.4 0 3 3 0 0 0-.667-.3.667.667 0 1 0-.373 1.28zm12 5.387a3 3 0 0 0-.666.3 1.39 1.39 0 0 1-1.4 0 3.09 3.09 0 0 0-3.027 0 1.41 1.41 0 0 1-1.413 0 3.09 3.09 0 0 0-3.027 0 1.39 1.39 0 0 1-1.4 0 3 3 0 0 0-.667-.3.667.667 0 0 0-.373 1.28q.196.058.373.16a2.67 2.67 0 0 0 2.734 0 1.73 1.73 0 0 1 1.706 0 2.77 2.77 0 0 0 2.747 0 1.73 1.73 0 0 1 1.707 0c.422.241.9.37 1.386.373.47 0 .931-.13 1.334-.373a1.7 1.7 0 0 1 .373-.16.667.667 0 0 0-.373-1.28zm0-3.334a3 3 0 0 0-.666.3 1.39 1.39 0 0 1-1.4 0 3.09 3.09 0 0 0-3.027 0 1.41 1.41 0 0 1-1.413 0 3.09 3.09 0 0 0-3.027 0 1.39 1.39 0 0 1-1.4 0 3 3 0 0 0-.667-.3.667.667 0 0 0-.88.454.666.666 0 0 0 .454.826q.196.058.373.16a2.67 2.67 0 0 0 2.733 0 1.73 1.73 0 0 1 1.707 0 2.77 2.77 0 0 0 2.747 0 1.73 1.73 0 0 1 1.706 0c.423.242.9.37 1.387.374a2.6 2.6 0 0 0 1.333-.374q.177-.102.374-.16a.666.666 0 1 0-.374-1.28z"
  }
) }), O0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...l, children: [
  /* @__PURE__ */ a("g", { clipPath: "url(#weather_svg__a)", children: /* @__PURE__ */ a(
    "path",
    {
      fill: "currentColor",
      d: "M5.625 11.25a.75.75 0 0 0-.75.75v.75a.75.75 0 1 0 1.5 0V12a.75.75 0 0 0-.75-.75m10.875-6h-.825c-.1-.47-.286-.917-.547-1.32l.622-.578a.753.753 0 0 0-1.065-1.065l-.577.585a3.8 3.8 0 0 0-1.358-.547V1.5a.75.75 0 1 0-1.5 0v.825c-.47.1-.917.286-1.32.548l-.577-.586a.753.753 0 1 0-1.066 1.066l.585.577a3.8 3.8 0 0 0-.577 1.5 4.3 4.3 0 0 0-1.17-.18A4.5 4.5 0 0 0 2.67 9.098a2.625 2.625 0 0 0-.345 4.935.9.9 0 0 0 .3.06.75.75 0 0 0 .3-1.44 1.11 1.11 0 0 1-.675-1.028A1.125 1.125 0 0 1 3.375 10.5a.75.75 0 0 0 .75-.75 3 3 0 0 1 5.835-.968.75.75 0 0 0 .585.503 1.74 1.74 0 0 1 .705 3.172.754.754 0 0 0 .825 1.26 3.26 3.26 0 0 0 1.425-2.715 3.3 3.3 0 0 0-.337-1.44q.482-.157.907-.434l.578.584a.75.75 0 0 0 1.266-.206.75.75 0 0 0-.164-.821l-.585-.578c.257-.415.43-.876.51-1.357h.825a.75.75 0 1 0 0-1.5m-2.902 2.34A2.25 2.25 0 0 1 12 8.25h-.045a3 3 0 0 0-.75-.345 4.45 4.45 0 0 0-1.5-1.785V6a2.25 2.25 0 0 1 .653-1.59 2.325 2.325 0 0 1 3.187 0 2.25 2.25 0 0 1 0 3.188zM5.625 15a.75.75 0 0 0-.75.75v.75a.75.75 0 1 0 1.5 0v-.75a.75.75 0 0 0-.75-.75m3-.75a.75.75 0 0 0-.75.75v.75a.75.75 0 1 0 1.5 0V15a.75.75 0 0 0-.75-.75m0-3.75a.75.75 0 0 0-.75.75V12a.75.75 0 1 0 1.5 0v-.75a.75.75 0 0 0-.75-.75"
    }
  ) }),
  /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "weather_svg__a", children: /* @__PURE__ */ a("path", { fill: "#fff", d: "M0 0h18v18H0z" }) }) })
] }), G0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      stroke: "#e9eaeb",
      strokeWidth: 1.688,
      d: "M14.625 7.313V6.75a2.25 2.25 0 0 0-2.25-2.25h-9a2.25 2.25 0 0 0-2.25 2.25v4.5a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-.562m0-3.376h1.125c.621 0 1.125.504 1.125 1.125v1.126c0 .62-.504 1.124-1.125 1.124h-1.125m0-3.374v3.375"
    }
  ),
  /* @__PURE__ */ a("path", { stroke: "#ff4d4f", strokeLinecap: "round", strokeWidth: 1.688, d: "M4.5 6.75v4.5" })
] }), X0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      stroke: "#e9eaeb",
      strokeWidth: 1.688,
      d: "M14.625 7.313V6.75a2.25 2.25 0 0 0-2.25-2.25h-9a2.25 2.25 0 0 0-2.25 2.25v4.5a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-.562m0-3.376h1.125c.621 0 1.125.504 1.125 1.125v1.126c0 .62-.504 1.124-1.125 1.124h-1.125m0-3.374v3.375"
    }
  ),
  /* @__PURE__ */ a("path", { stroke: "#52c41a", strokeLinecap: "round", strokeWidth: 1.688, d: "M4.5 6.75v4.5m6.875-4.5v4.5M8 6.75v4.5" })
] }), Y0 = (l) => /* @__PURE__ */ o("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", ...l, children: [
  /* @__PURE__ */ a(
    "path",
    {
      stroke: "#e9eaeb",
      strokeWidth: 1.688,
      d: "M14.625 7.313V6.75a2.25 2.25 0 0 0-2.25-2.25h-9a2.25 2.25 0 0 0-2.25 2.25v4.5a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-.562m0-3.376h1.125c.621 0 1.125.504 1.125 1.125v1.126c0 .62-.504 1.124-1.125 1.124h-1.125m0-3.374v3.375"
    }
  ),
  /* @__PURE__ */ a("path", { stroke: "#ffc53d", strokeLinecap: "round", strokeWidth: 1.688, d: "M4.5 6.75v4.5M8 6.75v4.5" })
] }), J0 = {
  ai: u,
  aiColored: x,
  aiMenu: M,
  add: f,
  minus: g0,
  close: q,
  left: v0,
  prev: B0,
  next: f0,
  down: U,
  polygon: S0,
  cut: T,
  archive: C,
  asc: V,
  desc: P,
  sort: W0,
  basket: H,
  bluetooth: A,
  border: S,
  calendar: B,
  camera: L,
  cameraMenu: z,
  cameraSoil: _0,
  chart: k,
  chartBars: y,
  check: R,
  compare: _,
  compareFull: W,
  copy: F,
  edit: J,
  editLine: K,
  day: E,
  night: u0,
  dew: j,
  diagram: $,
  dnd: I,
  download: O,
  email: Q,
  emptyTimeline: a0,
  exit: l0,
  expand: o0,
  info: c0,
  list: i0,
  lock: s0,
  map: h0,
  mapMenu: w0,
  more: d0,
  moreHorizontal: m0,
  navigator: p0,
  note: x0,
  past: M0,
  remove: L0,
  search: z0,
  send: k0,
  settings: y0,
  share: R0,
  sortTop: F0,
  stage: b0,
  stageAi: Z0,
  table: D0,
  temperature: N0,
  time: E0,
  topCircle: P0,
  upload: $0,
  warning: I0,
  water: U0,
  pin: C0,
  pinOnMap: V0,
  team: T0,
  weather: O0,
  fields: e0,
  dashboard: N,
  cropRotation: b,
  shovel: q0,
  crops: D,
  plant: H0,
  harvesting: n0,
  planting: A0,
  tractor: j0,
  cropler: Z,
  increasing: t0,
  increasingDown: r0,
  batteryEmpty: G0,
  batteryFull: X0,
  batteryMiddle: Y0,
  drop: G,
  drop2: X,
  drop3: Y
}, t1 = ({ name: l, width: e, height: n, className: r }) => {
  const t = J0[l];
  return t ? /* @__PURE__ */ a(t, { className: r, width: e, height: n }) : null;
};
export {
  l1 as AuthTemplate,
  o1 as Button,
  e1 as Count,
  t1 as Icon,
  n1 as Tag
};
